/* eslint-disable react/no-direct-mutation-state */
/* eslint-disable no-unused-vars */
import { Card, LinearProgress } from "@material-ui/core";
import axios from "axios";
import {
  MDBCol,
  MDBPageItem,
  MDBPageNav,
  MDBPagination,
  MDBRow,
} from "mdbreact";
import Moment from "moment";
import React, { Component } from "react";
import {
  Button,
  ButtonToolbar,
  Col,
  Form,
  Modal,
  Table,
} from "react-bootstrap";
import { toAbsoluteUrl } from "../../../_metronic/_helpers";
import AppConfig from "../../config/AppConfig";

const bgImage = toAbsoluteUrl("/media/bg/bg-10.jpg");
class DataLog extends Component {
  constructor(props, context) {
    super(props, context);
    this.closeModal = this.closeModal.bind(this);
    this.modalDetail = this.modalDetail.bind(this);
  }
  state = {
    // MODAL ============================
    modalDetail: false,
    // ==================================
    loadingLog: false,
    loadingDetails: false,
    // ==================================
    getLogs: [],
    logTypes: [],
    // Search & Pagination
    keyword: "",
    jenis: "",
    log_tgl_start: "",
    log_tgl_end: "",
    limit: 10,
    start: 0,
    totalData: 0,
    totalPaginationNumber: 0,
    currentPage: 1,
    pageLimit: 10,
    showFrom: 0,
    // Detail
    nm_pengguna: "",
    username: "",
    nm_lemb: "",
    jenis_log: "",
    waktu: "",
    keterangan: "",
    log_ip: "",
  };

  closeModal() {
    this.setState({
      modalDetail: false,
    });
  }

  onInputChangeName = (e, type) => {
    this.setState({
      [type]: e.target.value,
    });
  };

  // List ============================================================================
  dataLogList() {
    let sessiondata = JSON.parse(localStorage.getItem("sessiondata"));
    // console.log("session data : ", sessiondata);

    this.setState({ loadingLog: true });

    var formData = new FormData();
    formData.append("data[keyword]", this.state.keyword);
    formData.append("data[jenis]", this.state.jenis);
    formData.append("data[log_tgl_start]", this.state.log_tgl_start);
    formData.append("data[log_tgl_end]", this.state.log_tgl_end);
    axios
      .post(
        AppConfig.DataLog +
          "?limit=" +
          this.state.limit +
          "&start=" +
          this.state.start,
        formData
      )
      .then((res) => {
        console.log(res);
        this.setState(
          {
            loadingLog: false,
            loadingSearch: false,
            getLogs: res.data.result.data,
            logTypes: res.data.result.a_jenis,
            totalData: res.data.result.total_data,
            totalPaginationNumber: Math.ceil(
              res.data.result.total_data / this.state.limit
            ),
            showFrom: (this.state.currentPage - 1) * this.state.limit + 1,
          },
          () => {
            // console.log(this.state.getUsers);
          }
        );
      })
      .catch((err) => {
        console.log(err);
      });
  }

  componentDidMount() {
    this.dataLogList();
  }

  // Detail Log ============================================================================
  modalDetail = (val) => {
    this.setState({ modalDetail: true, loadingDetails: true });
    console.log(val);

    const timer = setTimeout(
      () => this.setState({ loadingDetails: false }),
      1000
    );

    this.setState({
      modalDetail: true,
      loadingDetails: true,
      nm_pengguna: val.nm_pengguna,
      username: val.username,
      nm_lemb: val.nm_lemb,
      jenis_log: val.log_type,
      waktu: val.log_time,
      keterangan: val.log_activity,
      log_ip: val.log_ip,
    });
    return () => clearTimeout(timer);
  };

  // Searh
  onClickSearch = (e) => {
    this.setState(
      {
        loadingSearch: true,
        loadingList: true,
        currentPage: 1,
      },
      () => {
        this.componentDidMount();
      }
    );
  };
  onClickResetKeyword = (e) => {
    this.setState(
      {
        keyword: "",
        loadingList: true,
        currentPage: 1,
      },
      () => {
        this.componentDidMount();
      }
    );
  };

  // Pagination
  getPaginationGroup = () => {
    let start =
      Math.floor((this.state.currentPage - 1) / this.state.pageLimit) *
      this.state.pageLimit;
    return new Array(this.state.pageLimit)
      .fill()
      .map((_, idx) => start + idx + 1);
  };

  pagination(e, numb) {
    let dataStart = numb * this.state.limit - this.state.limit;
    this.setState(
      {
        start: dataStart,
        currentPage: numb,
      },
      () => {
        this.componentDidMount();
      }
    );
  }
  firstPagination = () => {
    let first = this.state.currentPage / this.state.currentPage;
    let dataStart = first * this.state.limit - this.state.limit;
    this.setState(
      {
        start: dataStart,
        currentPage: first,
      },
      () => {
        this.componentDidMount();
      }
    );
  };
  prevPagination = () => {
    let prev = this.state.currentPage - 1;
    let dataStart = prev * this.state.limit - this.state.limit;
    this.setState(
      {
        start: dataStart,
        currentPage: prev,
      },
      () => {
        this.componentDidMount();
      }
    );
  };
  nextPagination = () => {
    let next = this.state.currentPage + 1;
    let dataStart = next * this.state.limit - this.state.limit;
    this.setState(
      {
        start: dataStart,
        currentPage: next,
      },
      () => {
        this.componentDidMount();
      }
    );
  };
  lastPagination = () => {
    let last = this.state.totalPaginationNumber;
    let dataStart = last * this.state.limit - this.state.limit;
    this.setState(
      {
        start: dataStart,
        currentPage: last,
      },
      () => {
        this.componentDidMount();
      }
    );
  };

  // Layout ============================================================================
  render() {
    let userdata = JSON.parse(localStorage.getItem("sessiondata"));

    let maxDate = Moment(new Date()).format("YYYY-MM-DD");

    let i = 0;

    let no = this.state.showFrom - 1;

    let list_logs = [];
    if (this.state.getLogs !== undefined) {
      for (var key in this.state.getLogs) {
        list_logs[i] = {
          result: this.state.getLogs[key],
        };
        i++;
      }
    }
    let list_log_Types = [];
    if (this.state.logTypes !== undefined) {
      for (var obj in this.state.logTypes) {
        list_log_Types[i] = {
          key: obj,
          result: this.state.logTypes[obj],
        };
        i++;
      }
    }

    let pagination = <></>;
    if (this.state.loadingLog === false) {
      pagination = (
        <>
          <div className="col-md-8" style={{ textAlign: "center" }}>
            <MDBRow>
              <MDBCol>
                <MDBPagination circle>
                  <MDBPageItem
                    className={`prev ${
                      this.state.currentPage === 1 ? "disabled" : ""
                    }`}
                  >
                    <MDBPageNav
                      className="page-link"
                      onClick={(e) => this.firstPagination(e)}
                    >
                      <span>First</span>
                    </MDBPageNav>
                  </MDBPageItem>
                  <MDBPageItem
                    className={`prev ${
                      this.state.currentPage === 1 ? "disabled" : ""
                    }`}
                  >
                    <MDBPageNav
                      className="page-link"
                      aria-label="Previous"
                      onClick={(e) => this.prevPagination(e)}
                    >
                      <span aria-hidden="true">&laquo;</span>
                      <span className="sr-only">Previous</span>
                    </MDBPageNav>
                  </MDBPageItem>
                  {this.getPaginationGroup()
                    .filter(
                      (index) => index <= this.state.totalPaginationNumber
                    )
                    .map((item, index) => (
                      <MDBPageItem
                        active={this.state.currentPage === item ? true : false}
                        key={index}
                      >
                        <MDBPageNav
                          className="page-link"
                          onClick={(e) => this.pagination(e, item)}
                        >
                          {item}
                        </MDBPageNav>
                      </MDBPageItem>
                    ))}
                  <MDBPageItem
                    disabled={
                      this.state.currentPage ===
                      this.state.totalPaginationNumber
                        ? true
                        : false
                    }
                  >
                    <MDBPageNav
                      className="page-link"
                      onClick={(e) => this.nextPagination(e)}
                    >
                      &raquo;
                    </MDBPageNav>
                  </MDBPageItem>
                  <MDBPageItem
                    disabled={
                      this.state.currentPage ===
                      this.state.totalPaginationNumber
                        ? true
                        : false
                    }
                  >
                    <MDBPageNav
                      className="page-link"
                      onClick={(e) => this.lastPagination(e)}
                    >
                      Last
                    </MDBPageNav>
                  </MDBPageItem>
                </MDBPagination>
              </MDBCol>
            </MDBRow>
          </div>
        </>
      );
    }

    return (
      <>
        <div
          className="row row-paddingless"
          style={{
            backgroundImage: `url(${bgImage})`,
            padding: "2%",
            borderRadius: "5px",
            marginBottom: "20px",
          }}
        >
          <div className="col-md-12 text-white" style={{ textAlign: "left" }}>
            <h2 className="font-weight">Log Data</h2>
            <hr />
          </div>
          <div className="col-md-12 text-white" style={{ textAlign: "" }}>
            <div className="form-group row">
              <label className="col-xl-3 col-lg-3 col-form-label text-white">
                Kata Kunci
              </label>
              <div className="col-lg-9 col-xl-6">
                <div>
                  <input
                    type="text"
                    value={this.state.keyword}
                    onChange={(e) => this.onInputChangeName(e, "keyword")}
                    className={`form-control form-control-lg form-control-solid `}
                    placeholder="Masukan keyword : Username / Nama Pengguna"
                    name="keyword"
                  />
                </div>
              </div>
            </div>
            <div className="form-group row">
              <label className="col-xl-3 col-lg-3 col-form-label text-white">
                Jenis Log
              </label>
              <div className="col-lg-9 col-xl-6">
                <select
                  value={this.state.jenis}
                  onChange={(e) => this.onInputChangeName(e, "jenis")}
                  className="form-control form-control-lg form-control-solid"
                  name="jenis"
                >
                  <option value="">Semua</option>
                  {list_log_Types.map((list, i) => (
                    <option value={list.key}>{list.result}</option>
                  ))}
                </select>
              </div>
            </div>
            <div className="form-group row">
              <label className="col-xl-3 col-lg-3 col-form-label text-white">
                Rentang Waktu
              </label>
              <div className="col-lg-9 col-xl-6">
                <Form.Row>
                  <Form.Group as={Col} controlId="log_tgl_start">
                    <Form.Control
                      type="date"
                      value={this.state.log_tgl_start}
                      onChange={(e) =>
                        this.onInputChangeName(e, "log_tgl_start")
                      }
                    />
                  </Form.Group>
                  <label className="col-form-label text-white">s/d</label>
                  <Form.Group as={Col} controlId="log_tgl_end">
                    <Form.Control
                      type="date"
                      max={maxDate}
                      value={this.state.log_tgl_end}
                      onChange={(e) => this.onInputChangeName(e, "log_tgl_end")}
                    />
                  </Form.Group>
                </Form.Row>
              </div>
            </div>
            <div className="form-group row">
              <label className="col-xl-3 col-lg-3 col-form-label"></label>
              <div
                className="col-lg-9 col-xl-6"
                style={{ textAlign: "center" }}
              >
                <Button variant="primary" onClick={this.onClickSearch}>
                  Filter Data &nbsp;&nbsp;&nbsp;&nbsp;
                  <span className="fa fa-search"></span>
                </Button>
                <Button
                  variant="default"
                  onClick={this.onClickResetKeyword}
                  style={{ marginLeft: "10px" }}
                >
                  Reset &nbsp;&nbsp;&nbsp;&nbsp;
                  <span className="fa fa-times"></span>
                </Button>
              </div>
            </div>
          </div>
        </div>
        <Card style={{ padding: "2%" }}>
          {/*========================================== Begin Table ========================================== */}
          <Table responsive hover style={{ overflow: "auto" }}>
            <thead
              className="text-white"
              style={{ backgroundColor: "#3047ad" }}
            >
              <tr>
                <th
                  style={{
                    width: "5%",
                    fontSize: "12px",
                    textTransform: "uppercase",
                    verticalAlign: "middle",
                    textAlign: "center",
                  }}
                >
                  No
                </th>
                <th
                  style={{
                    width: "20%",
                    fontSize: "12px",
                    textTransform: "uppercase",
                    verticalAlign: "middle",
                  }}
                >
                  Nama Pengguna
                </th>
                <th
                  style={{
                    width: "20%",
                    fontSize: "12px",
                    textTransform: "uppercase",
                    verticalAlign: "middle",
                  }}
                >
                  Username
                </th>
                <th
                  style={{
                    width: "20%",
                    fontSize: "12px",
                    textTransform: "uppercase",
                    verticalAlign: "middle",
                  }}
                >
                  Nama Lembaga
                </th>
                <th
                  style={{
                    width: "20%",
                    fontSize: "12px",
                    textTransform: "uppercase",
                    verticalAlign: "middle",
                  }}
                >
                  Jenis Log
                </th>
                <th
                  style={{
                    width: "20%",
                    fontSize: "12px",
                    textTransform: "uppercase",
                    verticalAlign: "middle",
                  }}
                >
                  Waktu
                </th>
                <th
                  className="text-center"
                  style={{
                    width: "10%",
                    fontSize: "12px",
                    textTransform: "uppercase",
                    verticalAlign: "middle",
                    textAlign: "center",
                  }}
                >
                  Aksi
                </th>
              </tr>
            </thead>
            <tbody>
              {this.state.loadingLog === true ? (
                <tr>
                  <td colSpan="7">
                    <LinearProgress color="secondary" variant="query" />
                  </td>
                </tr>
              ) : list_logs.length > 0 ? (
                list_logs.map((list) => (
                  <tr key={list.result.log_id}>
                    <td
                      style={{ verticalAlign: "middle", textAlign: "center" }}
                    >
                      {(no = no + 1)}
                    </td>
                    <td style={{ verticalAlign: "middle" }}>
                      {list.result.nm_pengguna === "null"
                        ? "-"
                        : list.result.nm_pengguna}
                    </td>
                    <td style={{ verticalAlign: "middle" }}>
                      {list.result.username === "null"
                        ? "-"
                        : list.result.username}
                    </td>
                    <td style={{ verticalAlign: "middle" }}>
                      {list.result.nm_lemb}
                    </td>
                    <td style={{ verticalAlign: "middle" }}>
                      {list.result.log_type === "1"
                        ? "Umum"
                        : list.result.log_type === "2"
                        ? "Ajuan Dosen"
                        : list.result.log_type === "3"
                        ? "PDD"
                        : list.result.log_type === "4"
                        ? "Ajuan Prodi"
                        : list.result.log_type === "5"
                        ? "Data Dosen"
                        : list.result.log_type === "6"
                        ? "PDM"
                        : list.result.log_type === "7"
                        ? "SMS"
                        : list.result.log_type === " 9"
                        ? "Klaim Dosen"
                        : list.result.log_type === "10"
                        ? "Blacklist"
                        : list.result.log_type === "11"
                        ? "Prodi Khusus"
                        : list.result.log_type === "12"
                        ? "Referensi"
                        : list.result.log_type === "13"
                        ? "Perubahan PT"
                        : list.result.log_type === "14"
                        ? "Perubahan Prodi di PT"
                        : list.result.log_type === "15"
                        ? "Perubahan Yayasan"
                        : list.result.log_type === "16"
                        ? "User"
                        : list.result.log_type === "17"
                        ? "Transfer Data Prodi"
                        : list.result.log_type === "18"
                        ? "Transfer Data Dosen"
                        : list.result.log_type === "19"
                        ? "Penugasan"
                        : list.result.log_type === "20"
                        ? "Lembaga Non SP"
                        : list.result.log_type === "31"
                        ? "Sinkronisasi"
                        : list.result.log_type === "32"
                        ? "Ajuan Perubahan Periode"
                        : "-"}
                    </td>
                    <td style={{ verticalAlign: "middle" }}>
                      {Moment(list.result.log_time).format(
                        "YYYY-MM-DD, HH:mm:ss"
                      )}
                    </td>
                    <td
                      style={{ verticalAlign: "middle", textAlign: "center" }}
                    >
                      <ButtonToolbar
                        onClick={() => this.modalDetail(list.result)}
                        className="btn btn-icon btn-primary btn-sm"
                        style={{
                          minWidth: "50px",
                          borderRadius: "12px",
                        }}
                      >
                        <div>
                          <i
                            className="flaticon-eye"
                            style={{ color: "#FFFFFF", fontSize: "16px" }}
                          ></i>
                        </div>
                      </ButtonToolbar>
                    </td>
                  </tr>
                ))
              ) : (
                <>
                  <tr>
                    <td colSpan="7" style={{ textAlign: "center" }}>
                      <em>Data does not exist</em>
                    </td>
                  </tr>
                </>
              )}
            </tbody>
          </Table>
          <div className="row" style={{ marginTop: "10px" }}>
            <div className="col-md-4 text-left">
              {" "}
              <label style={{ fontSize: 11, fontStyle: "italic" }}>
                Page <strong>{this.state.currentPage}</strong> of{" "}
                <strong>{this.state.totalPaginationNumber}</strong>
              </label>
            </div>
            <div className="col-md-4">{pagination}</div>
            <div className="col-md-4 text-right">
              <label style={{ fontSize: 11, fontStyle: "italic" }}>
                Showing <strong>{this.state.showFrom}</strong> to{" "}
                <strong>
                  {this.state.showFrom + this.state.getLogs.length - 1}
                </strong>{" "}
                of <strong>{this.state.totalData}</strong> Data
              </label>
            </div>
          </div>
          {/*========================================== End Table ========================================== */}
        </Card>

        {/*========================================== Begin Modal Detail ========================================== */}
        <Modal
          size="lg"
          show={this.state.modalDetail}
          onHide={this.closeModal}
          backdrop="static"
          keyboard={false}
        >
          <Modal.Header closeButton>
            <Modal.Title>Details User</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {this.state.loadingDetails === true ? (
              <>
                <div className="row">
                  <div className="col-md-12">
                    <LinearProgress color="secondary" variant="query" />
                  </div>
                </div>
              </>
            ) : (
              <>
                <Table borderless responsive style={{ overflow: "auto" }}>
                  <tbody>
                    <tr>
                      <th>Nama Pengguna</th>
                      <th>:</th>
                      <td>{this.state.nm_pengguna}</td>
                    </tr>
                    <tr>
                      <th>Username</th>
                      <th>:</th>
                      <td>{this.state.username}</td>
                    </tr>
                    <tr>
                      <th>Nama Lembaga</th>
                      <th>:</th>
                      <td>{this.state.nm_lemb}</td>
                    </tr>
                    <tr>
                      <th>Jenis Log</th>
                      <th>:</th>
                      <td>{this.state.jenis_log}</td>
                    </tr>
                    <tr>
                      <th>Waktu</th>
                      <th>:</th>
                      <td>{this.state.waktu}</td>
                    </tr>
                    <tr>
                      <th>Keterangan</th>
                      <th>:</th>
                      <td>{this.state.keterangan}</td>
                    </tr>
                    <tr>
                      <th>Log IP</th>
                      <th>:</th>
                      <td>{this.state.log_ip}</td>
                    </tr>
                  </tbody>
                </Table>
              </>
            )}
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={this.closeModal}>
              Kembali
            </Button>
          </Modal.Footer>
        </Modal>
        {/*========================================== End Modal Detail ========================================== */}
      </>
    );
  }
}
export default DataLog;
